<template>
    <div>exit</div>
</template>

<script>
export default {
    name: 'Logout',
    methods: {
        logout(){
            localStorage.clear()
            this.$router.push("/")
        }
    },
    beforeMount(){
        this.logout()
    }
    
}
</script>